import React from "react";
import styled from "styled-components";
import StatusItem from "@src/components/Item/StatusChangeItem";
import { useGetStatusItems } from "@src/hooks/item/useStatusItem";
import { transferToNative } from "@src/lib/WebAppBridge";
import Header from "@src/components/Header";
import { StatusItemType } from "@src/types/item.type";

const StatusChangeItemList = () => {
    const { data } = useGetStatusItems();

    const handleItemClick = (item: StatusItemType) => {
        transferToNative(JSON.stringify({ itemId: item.item_id, bidType: item.bid_type }), "openBidDetail");
    };

    return (
        <Layout>
            <Header title="오늘 변경된 매물" />
            <ItemBox>
                {data?.map((item: StatusItemType) => (
                    <StatusItem key={item.item_id} {...item} onClick={() => handleItemClick(item)} />
                ))}
            </ItemBox>
        </Layout>
    );
};

export default StatusChangeItemList;

const Layout = styled.div``;

const ItemBox = styled.div`
    height: calc(100vh - 56px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
        display: none;
    }
`;
